import { getSDKConfig } from '../shares/lib/getSDKConfig';
import { SwipeGamesItem } from '../shares/model/swipe';

// interface Game {
//   gameId: string;
//   name: string;
//   colorGradient: string[];
// }

export const findGameInTheList = (
  gameId: string | null,
): SwipeGamesItem | undefined => {
  const swipeSDKConfig = getSDKConfig();
  return swipeSDKConfig.swipeGames?.gameListConfig.gameList.find(
    (game: SwipeGamesItem) => game.gameId.toString() === gameId,
  );
};

export default findGameInTheList;
